import { oidcClient } from '../helpers/oidcClient.js';
import { getLanguageCode } from '../i18n.js';
import { updateInitialSearchParamsIKnowWhatIDo } from '../urlHandling/initialSearchParams.js';
import { createNewTourURL, createToursURL, createTourURL, } from '../urlHandling/urlCreate.js';
import { normalizeURL } from '../urlHandling/urlNormalizer.js';
import { resolveDeployPrefix } from './deployPrefixResolver.js';
export function finishAuthenticationProcedure() {
    const postLogoutUrl = localStorage.getItem('appPostLogoutURL');
    if (postLogoutUrl) {
        localStorage.removeItem('appPostLogoutURL');
        document.location = postLogoutUrl;
        return;
    }
    const preLoginUrl = localStorage.getItem('appPreLoginURL');
    if (!preLoginUrl) {
        return;
    }
    try {
        const searchParams = new URLSearchParams(document.location.search);
        const preLoginSearchParams = new URL(preLoginUrl).searchParams;
        if (preLoginSearchParams.has('intsso') && !searchParams.has('intsso')) {
            searchParams.set('intsso', '');
            document.location.search = searchParams.toString();
            return;
        }
        if (preLoginSearchParams.has('envname') && !searchParams.has('envname')) {
            searchParams.set('envname', preLoginSearchParams.get('envname'));
            document.location.search = searchParams.toString();
            return;
        }
        oidcClient.handleStateIfInURL(searchParams).then(async (results) => {
            switch (results.status) {
                case 'completed': {
                    updateInitialSearchParamsIKnowWhatIDo(preLoginSearchParams);
                    localStorage.removeItem('appPreLoginURL');
                    const { kind, bag, normalizedURL } = normalizeURL(preLoginUrl, getLanguageCode(), undefined, resolveDeployPrefix());
                    if (['tour', 'recordedtrack'].includes(kind)) {
                        const url = bag.tourId
                            ? createTourURL(bag.tourId, kind === 'tour' ? 'normal' : 'recordedtrack', getLanguageCode())
                            : createNewTourURL(getLanguageCode());
                        document.location = location.origin + url;
                    }
                    else if (['segment', 'route'].includes(kind)) {
                        document.location = normalizedURL;
                    }
                    else {
                        document.location =
                            location.origin + createToursURL(getLanguageCode());
                    }
                    return;
                }
                case 'invalid':
                    console.log('Login failed', results.msg);
                    return;
                case 'error': {
                    console.log('Login failed', results.msg);
                    localStorage.removeItem('appPreLoginURL');
                    document.location = preLoginUrl;
                    return;
                }
                case 'nothing': {
                    return;
                }
            }
        });
    }
    catch (error) {
        console.log('Login failed', error);
    }
}
//# sourceMappingURL=sso.js.map